import { render, staticRenderFns } from "./ReviewStatusChip.vue?vue&type=template&id=7f21c153&scoped=true&"
import script from "./ReviewStatusChip.vue?vue&type=script&lang=js&"
export * from "./ReviewStatusChip.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStatusChip.vue?vue&type=style&index=0&id=7f21c153&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21c153",
  null
  
)

export default component.exports